import { Component, ElementRef, inject, input, OnDestroy, OnInit, output } from "@angular/core"
import { MatButtonModule } from "@angular/material/button"
import { TranslatePipe } from "../../../i18n/pipes/translate.pipe"
import { ScrollBottomComponent } from "../scroll-bottom/scroll-bottom.component"
import Cookies from "js-cookie"
import { RMBTTermsV6 } from "../../../test/constants/strings"

@Component({
  selector: "app-agreement",
  imports: [MatButtonModule, TranslatePipe, ScrollBottomComponent],
  templateUrl: "./agreement.component.html",
  styleUrl: "./agreement.component.scss",
})
export class AgreementComponent implements OnInit, OnDestroy {
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef)
  private scrollInterval?: ReturnType<typeof setInterval>
  agreeChange = output<void>()
  cancelChange = output<void>()
  storageItem = input.required<[string, string]>()
  text = input.required<string>()
  title = input.required<string>()
  isRead = false

  ngOnInit(): void {
    this.watchForScroll()
  }

  watchForScroll = () => {
    if (!globalThis.document) {
      return
    }
    this.scrollInterval = setInterval(() => {
      const container = this.element.nativeElement.querySelector<HTMLElement>(".app-wrapper")
      if (!container || !this.text()?.trim()) return
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 8) {
        this.isRead = true
        clearInterval(this.scrollInterval)
      }
    }, 100)
  }

  ngOnDestroy(): void {
    clearInterval(this.scrollInterval)
  }

  cancel() {
    this.cancelChange.emit()
  }

  agree() {
    const value = this.storageItem()
    if (value && value.length > 1) {
      Cookies.set(RMBTTermsV6, "true", { expires: 365 }) // Legacy cookie for compatibility
    }
    if (globalThis.localStorage && value && value.length > 1) {
      localStorage.setItem(value[0], value[1])
    }
    this.agreeChange.emit()
  }
}
